import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ContinueWithBackAndTempSaveButtons } from 'components/base/BottomStepComponent';


import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { ActionType, APIStatus, CampaignType } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';
import { scrollToAnchor } from 'components/campaignStreamline/CreateCampaignHandleError';
import { CREATE_EVENT_PROPERTIES_PAGE_CONFIG } from 'containers/engagement/events/EventCreationConfig';

const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});
const CreateEventPropertiesPage = ({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
  onStepChange,
  onSaveTemp,
}) => {
  const currentStep = 1;
  const params = useParams();
  const formContext = useFormContext()
  const {
    watch,
  } = formContext;

  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  const campaignTypeField = 'campaignType';
  const watchCampaignType = watch(campaignTypeField);

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);


  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);

  const backToLastStep = () => onStepChange(currentStep - 1)
  const goToNextStep = () => {
    onStepChange( currentStep + 1 )
  }

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_EVENT_PROPERTIES_PAGE_CONFIG}
        hidePreview={true}
      />
      <ContinueWithBackAndTempSaveButtons
        backAction={backToLastStep}
        {...params.id ? {} : {
          saveTempText: "Save as draft",
          saveTempAction: () => {
            onSaveTemp && onSaveTemp(formContext)
          }
        }}
        continueAction={goToNextStep}
      />
      <PublishCampaignPrompt
        campaignId={params.id}
        campaignType={CampaignType.ticketCampaign}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/events'}
      />
    </>
  );
}

export default connect(mapStateToProps)(CreateEventPropertiesPage);
